import * as React from 'react';
import { IconSvgProps } from '../types';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon: {
    iconName?: string;
    iconData?: string;
    width?: number;
    height?: number;
    color?: string;
  };
}
export const IconHub = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${props.icon?.width || 16} ${props.icon?.height || 16}`}
    dangerouslySetInnerHTML={{
      __html: props.icon?.iconData || '',
    }}
    style={{ color: props.icon.color }}
    {...props}
  />
);
export const Logo: React.FC<IconSvgProps> = ({
  size = 36,
  width,
  height,
  ...props
}) => (
  <svg
    fill="currentColor"
    height={size || height}
    width={size || width}
    {...props}
    viewBox="0 0 95.469970703125 95.9996337890625"
  >
    <path d="M15.95,95.81C16.8826,96.1954,17.9554,95.9824,18.67,95.27L31.75,82.17L43.95,82.17C49.8468,82.1866,54.639,77.4168,54.65,71.52L54.65,65L57.53,65L73.1,80.57C73.8151,81.2869,74.8919,81.5016,75.8273,81.1139C76.7627,80.7262,77.3718,79.8126,77.37,78.8L77.37,65L83.37,65C90.0504,64.9945,95.4645,59.5804,95.47,52.9L95.47,12.1C95.4645,5.43133,90.0686,0.0220332,83.4,0L32.91,0C26.2296,0.00551486,20.8155,5.41964,20.81,12.1L20.81,29.87L10.66,29.87C4.77493,29.8755,0.00551319,34.6449,0,40.53L0,71.53C0.0165231,77.4073,4.78272,82.1645,10.66,82.17L14.41,82.17L14.41,93.5C14.4093,94.5105,15.017,95.422,15.95,95.81ZM25.81,12.1C25.8155,8.18106,28.9911,5.00551,32.91,5L83.4,5C87.3189,5.00551,90.4945,8.18106,90.5,12.1L90.5,52.93C90.4945,56.8489,87.3189,60.0245,83.4,60.03L74.87,60.03C73.4893,60.03,72.37,61.1493,72.37,62.53L72.37,72.78L60.37,60.78C59.9013,60.2856,59.2512,60.0039,58.57,60L32.91,60C28.9911,59.9945,25.8155,56.8189,25.81,52.9L25.81,12.1ZM10.66,77.17C7.53407,77.17,5,74.6359,5,71.51L5,40.51C5,37.3841,7.53407,34.85,10.66,34.85L20.81,34.85L20.81,52.93C20.832,59.5986,26.2413,64.9945,32.91,65L49.65,65L49.65,71.48C49.65,74.6059,47.1159,77.14,43.99,77.14L30.75,77.14C30.0865,77.1388,29.4498,77.4014,28.98,77.87L19.4,87.44L19.4,79.64C19.4,78.2593,18.2807,77.14,16.9,77.14L10.66,77.17Z" />
    <path d="M38.47999954223633,48.05999961853027L47.749999542236324,48.05999961853027C51.02299954223633,48.06219961853027,54.13989954223633,49.45879961853027,56.31999954223633,51.89999961853027C57.31399954223633,53.013499618530275,59.05599954223633,53.013499618530275,60.04999954223633,51.89999961853027C62.23009954223633,49.45879961853027,65.34699954223633,48.062099618530276,68.61999954223633,48.05999961853027L77.85999954223632,48.05999961853027C79.24069954223633,48.05999961853027,80.35999954223632,46.940699618530275,80.35999954223632,45.55999961853027L80.35999954223632,17.899999618530273C80.35999954223632,16.519289618530273,79.24069954223633,15.399999618530273,77.85999954223632,15.399999618530273L68.58999954223633,15.399999618530273C64.78409954223633,15.402851108530273,61.09609954223633,16.720509618530272,58.14999954223633,19.129999618530274C55.21459954223633,16.729179618530274,51.54219954223633,15.412048318530273,47.749999542236324,15.399999618530273L38.47999954223633,15.399999618530273C37.09928954223633,15.399999618530273,35.97999954223633,16.519289618530273,35.97999954223633,17.899999618530273L35.97999954223633,45.55999961853027C35.97999954223633,46.940699618530275,37.09928954223633,48.05999961853027,38.47999954223633,48.05999961853027ZM68.58999954223633,20.399999618530273L75.32999954223632,20.399999618530273L75.32999954223632,43.05999961853027L68.58999954223633,43.05999961853027C65.82069954223633,43.05019961853027,63.09349954223633,43.737999618530274,60.65999954223633,45.05999961853027L60.65999954223633,23.599999618530273C62.79319954223632,21.552789618530273,65.63339954223633,20.406669618530273,68.58999954223633,20.399999618530273ZM40.989999542236326,20.399999618530273L47.749999542236324,20.399999618530273C50.706599542236326,20.406669618530273,53.54679954223633,21.552789618530273,55.67999954223633,23.599999618530273L55.67999954223633,45.109999618530274C53.24649954223633,43.78799961853028,50.519299542236325,43.10019961853027,47.749999542236324,43.109999618530274L40.97999954223633,43.109999618530274L40.989999542236326,20.399999618530273Z" />
  </svg>
);

export const Activity = ({
  fill,
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      height={size || height || 24}
      viewBox="0 0 24 24"
      width={size || width || 24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="M6.918 14.854l2.993-3.889 3.414 2.68 2.929-3.78" />
        <path d="M19.668 2.35a1.922 1.922 0 11-1.922 1.922 1.921 1.921 0 011.922-1.922z" />
        <path d="M20.756 9.269a20.809 20.809 0 01.194 3.034c0 6.938-2.312 9.25-9.25 9.25s-9.25-2.312-9.25-9.25 2.313-9.25 9.25-9.25a20.931 20.931 0 012.983.187" />
      </g>
    </svg>
  );
};

export const TagUser = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="none"
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 18.86h-.76c-.8 0-1.56.31-2.12.87l-1.71 1.69c-.78.77-2.05.77-2.83 0l-1.71-1.69c-.56-.56-1.33-.87-2.12-.87H6c-1.66 0-3-1.33-3-2.97V4.98c0-1.64 1.34-2.97 3-2.97h12c1.66 0 3 1.33 3 2.97v10.91c0 1.63-1.34 2.97-3 2.97Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        d="M12 10a2.33 2.33 0 1 0 0-4.66A2.33 2.33 0 0 0 12 10ZM16 15.66c0-1.8-1.79-3.26-4-3.26s-4 1.46-4 3.26"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};

export const WechatPayIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path d="M404.511405 600.865957c-4.042059 2.043542-8.602935 3.223415-13.447267 3.223415-11.197016 0-20.934798-6.169513-26.045189-15.278985l-1.959631-4.296863-81.56569-178.973184c-0.880043-1.954515-1.430582-4.14746-1.430582-6.285147 0-8.251941 6.686283-14.944364 14.938224-14.944364 3.351328 0 6.441713 1.108241 8.94165 2.966565l96.242971 68.521606c7.037277 4.609994 15.433504 7.305383 24.464181 7.305383 5.40101 0 10.533914-1.00284 15.328104-2.75167l452.645171-201.459315C811.496653 163.274644 677.866167 100.777241 526.648117 100.777241c-247.448742 0-448.035176 167.158091-448.035176 373.361453 0 112.511493 60.353576 213.775828 154.808832 282.214547 7.582699 5.405103 12.537548 14.292518 12.537548 24.325012 0 3.312442-0.712221 6.358825-1.569752 9.515724-7.544837 28.15013-19.62599 73.202209-20.188808 75.314313-0.940418 3.529383-2.416026 7.220449-2.416026 10.917654 0 8.245801 6.692423 14.933107 14.944364 14.933107 3.251044 0 5.89015-1.202385 8.629541-2.7793l98.085946-56.621579c7.377014-4.266164 15.188934-6.89913 23.790846-6.89913 4.577249 0 9.003048 0.703011 13.174044 1.978051 45.75509 13.159718 95.123474 20.476357 146.239666 20.476357 247.438509 0 448.042339-167.162184 448.042339-373.372709 0-62.451354-18.502399-121.275087-51.033303-173.009356L407.778822 598.977957 404.511405 600.865957z"></path>
    </svg>
  );
};

export const AlipayIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path d="M902.095 652.871l-250.96-84.392s19.287-28.87 39.874-85.472c20.59-56.606 23.539-87.689 23.539-87.689l-162.454-1.339v-55.487l196.739-1.387v-39.227H552.055v-89.29h-96.358v89.294H272.133v39.227l183.564-1.304v59.513h-147.24v31.079h303.064s-3.337 25.223-14.955 56.606c-11.615 31.38-23.58 58.862-23.58 58.862s-142.3-49.804-217.285-49.804c-74.985 0-166.182 30.123-175.024 117.55-8.8 87.383 42.481 134.716 114.728 152.139 72.256 17.513 138.962-0.173 197.04-28.607 58.087-28.391 115.081-92.933 115.081-92.933l292.486 142.041c-11.932 69.3-72.067 119.914-142.387 119.844H266.37c-79.714 0.078-144.392-64.483-144.466-144.194V266.374c-0.074-79.72 64.493-144.399 144.205-144.47h491.519c79.714-0.073 144.396 64.49 144.466 144.203v386.764z m-365.76-48.895s-91.302 115.262-198.879 115.262c-107.623 0-130.218-54.767-130.218-94.155 0-39.34 22.373-82.144 113.943-88.333 91.519-6.18 215.2 67.226 215.2 67.226h-0.047z"></path>
    </svg>
  );
};

export const WeiboIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path d="M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2z m-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3z m45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zM785.3 443.5c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109-27.6-30.6-68.4-42.3-106-34.3-15.4 3.3-25.2 18.4-21.9 33.8 3.3 15.3 18.4 25.2 33.8 21.8 18.4-3.9 38.3 1.8 51.9 16.7 13.5 15 17.2 35.4 11.3 53.3-4.9 15.1 3.2 31.1 18.2 36z"></path>
      <path d="M885.1 237.5c-56.7-62.9-140.4-86.9-217.7-70.5-17.9 3.8-29.3 21.4-25.4 39.3 3.8 17.9 21.4 29.3 39.3 25.5 55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-0.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7 0.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z"></path>
    </svg>
  );
};

export const ZhiHuIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path d="M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7z m247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-0.1-8.1c0-0.6-0.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-0.7c-0.8 0-19.6-0.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-0.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 0.6-0.3 1.3-0.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c0.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-0.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c0.8-1.9 19-46.3 5.1-95.9l-0.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z"></path>
    </svg>
  );
};
export const WeiXinIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path d="M681.6 364.8c9.6 0 22.4 0 32 3.2-28.8-131.2-176-227.2-342.4-227.2C185.6 140.8 32 262.4 32 416c0 89.6 51.2 163.2 134.4 217.6l-35.2 96L249.6 672c41.6 9.6 76.8 16 118.4 16h32c-6.4-22.4-9.6-44.8-9.6-67.2 3.2-140.8 131.2-256 291.2-256z m-182.4-89.6c25.6 0 41.6 16 41.6 41.6s-16 41.6-41.6 41.6-51.2-16-51.2-41.6 25.6-41.6 51.2-41.6z m-236.8 83.2c-25.6 0-51.2-16-51.2-41.6s25.6-41.6 51.2-41.6 41.6 16 41.6 41.6-16 41.6-41.6 41.6zM992 617.6c0-131.2-134.4-236.8-288-236.8-163.2 0-288 105.6-288 236.8 0 131.2 128 236.8 288 236.8 35.2 0 67.2-9.6 102.4-16l92.8 48-25.6-80C940.8 755.2 992 691.2 992 617.6zM611.2 576c-16 0-35.2-16-35.2-32s16-32 35.2-32c25.6 0 41.6 16 41.6 32s-16 32-41.6 32z m185.6 0c-16 0-35.2-16-35.2-32s16-32 35.2-32c25.6 0 41.6 16 41.6 32s-16 32-41.6 32z m0 0"></path>
    </svg>
  );
};
export const GithubIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path d="M64 512c0 195.2 124.8 361.6 300.8 422.4 22.4 6.4 19.2-9.6 19.2-22.4v-76.8c-134.4 16-140.8-73.6-150.4-89.6-19.2-32-60.8-38.4-48-54.4 32-16 64 3.2 99.2 57.6 25.6 38.4 76.8 32 105.6 25.6 6.4-22.4 19.2-44.8 35.2-60.8-144-22.4-201.6-108.8-201.6-211.2 0-48 16-96 48-131.2-22.4-60.8 0-115.2 3.2-121.6 57.6-6.4 118.4 41.6 124.8 44.8 32-9.6 70.4-12.8 112-12.8 41.6 0 80 6.4 112 12.8 12.8-9.6 67.2-48 121.6-44.8 3.2 6.4 25.6 57.6 6.4 118.4 32 38.4 48 83.2 48 131.2 0 102.4-57.6 188.8-201.6 214.4 22.4 22.4 38.4 54.4 38.4 92.8v112c0 9.6 0 19.2 16 19.2C832 876.8 960 710.4 960 512c0-246.4-201.6-448-448-448S64 265.6 64 512z"></path>
    </svg>
  );
};

export const PDFIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      // fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M590.222222 79.644444L859.022222 347.943822V881.777778c0 37.700267-30.5664 68.266667-68.266666 68.266666H233.244444c-37.700267 0-68.266667-30.5664-68.266666-68.266666V147.911111c0-37.700267 30.5664-68.266667 68.266666-68.266667h356.977778z m-11.764622 28.444445H233.244444a39.822222 39.822222 0 0 0-39.799466 38.456889L193.422222 147.911111v733.866667a39.822222 39.822222 0 0 0 38.456889 39.799466L233.244444 921.6h557.511112a39.822222 39.822222 0 0 0 39.799466-38.456889L830.577778 881.777778V359.742578L578.4576 108.088889z"
        fill="currentColor"
      ></path>
      <path
        d="M854.755556 376.337067h-215.1424c-45.528178 0-82.551467-36.431644-83.5072-81.737956l-0.017067-1.792V79.644444h28.444444v213.162667c0 29.895111 23.819378 54.232178 53.515378 55.062756l1.564445 0.022755h215.1424v28.444445z"
        fill="currentColor"
      ></path>
      <path
        d="M56.888889 494.933333m28.444444 0l853.333334 0q28.444444 0 28.444444 28.444445l0 284.444444q0 28.444444-28.444444 28.444445l-853.333334 0q-28.444444 0-28.444444-28.444445l0-284.444444q0-28.444444 28.444444-28.444445Z"
        fill="currentColor"
      ></path>
      <path d="M318.435556 762.311111v-63.232h22.272c40.448 0 75.264-19.968 75.264-65.28 0-47.104-34.56-62.208-76.288-62.208H272.611556V762.311111h45.824z m19.968-99.328h-19.968v-55.04h18.688c22.016 0 34.304 6.656 34.304 25.856 0 18.688-10.752 29.184-33.024 29.184zM505.827556 762.311111c55.552 0 93.952-29.952 93.952-96.256 0-66.304-38.4-94.464-96.512-94.464h-54.784V762.311111h57.344z m-5.376-36.864h-6.144v-117.248h6.144c30.72 0 52.48 12.544 52.48 57.856s-21.76 59.392-52.48 59.392z m180.48 36.864v-72.704h65.024v-38.144h-65.024v-41.728h75.776v-38.144H635.107556V762.311111h45.824z"></path>
    </svg>
  );
};

export const EpubIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      // fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M590.222222 79.644444L859.022222 347.943822V881.777778c0 37.700267-30.5664 68.266667-68.266666 68.266666H233.244444c-37.700267 0-68.266667-30.5664-68.266666-68.266666V147.911111c0-37.700267 30.5664-68.266667 68.266666-68.266667h356.977778z m-11.764622 28.444445H233.244444a39.822222 39.822222 0 0 0-39.799466 38.456889L193.422222 147.911111v733.866667a39.822222 39.822222 0 0 0 38.456889 39.799466L233.244444 921.6h557.511112a39.822222 39.822222 0 0 0 39.799466-38.456889L830.577778 881.777778V359.742578L578.4576 108.088889z"
        fill="currentColor"
      ></path>
      <path
        d="M854.755556 376.337067h-215.1424c-45.528178 0-82.551467-36.431644-83.5072-81.737956l-0.017067-1.792V79.644444h28.444444v213.162667c0 29.895111 23.819378 54.232178 53.515378 55.062756l1.564445 0.022755h215.1424v28.444445z"
        fill="currentColor"
      ></path>
      <path
        d="M56.888889 494.933333m28.444444 0l853.333334 0q28.444444 0 28.444444 28.444445l0 284.444444q0 28.444444-28.444444 28.444445l-853.333334 0q-28.444444 0-28.444444-28.444445l0-284.444444q0-28.444444 28.444444-28.444445Z"
        fill="currentColor"
      ></path>
      <path d="M151,762 L283,762 L283,719.258065 L199.919255,719.258065 L199.919255,674.236559 L267.968944,674.236559 L267.968944,631.494624 L199.919255,631.494624 L199.919255,592.172043 L279.993789,592.172043 L279.993789,550 L151,550 L151,762 Z M323,762 L371.905357,762 L371.905357,691.61828 L395.675,691.61828 C438.569643,691.61828 476,669.392473 476,618.956989 C476,566.526882 439.116071,550 394.308929,550 L323,550 L323,762 Z M371.905357,651.44086 L371.905357,590.177419 L391.85,590.177419 C415.346429,590.177419 428.460714,597.586022 428.460714,618.956989 C428.460714,639.758065 416.985714,651.44086 393.216071,651.44086 L371.905357,651.44086 Z M592.043333,766 C645.833333,766 673,733.799472 673,662.274406 L673,550 L626.273333,550 L626.273333,667.688654 C626.273333,707.868074 614.048333,722.116095 592.043333,722.116095 C569.766667,722.116095 558.356667,707.868074 558.356667,667.688654 L558.356667,550 L510,550 L510,662.274406 C510,733.799472 537.981667,766 592.043333,766 Z M788.909091,550 C830.909091,550 864.454545,561.682796 864.454545,602.430108 C864.454545,621.236559 854.363636,641.752688 838,648.306452 L838,648.306452 L838,649.446237 C858.454545,655.145161 874,671.102151 874,699.311828 C874,742.623656 838.818182,762 794.636364,762 L794.636364,762 L718,762 L718,550 Z M791.090909,671.672043 L766.818182,671.672043 L766.818182,722.962366 L791.090909,722.962366 C814.545455,722.962366 826.545455,714.129032 826.545455,695.892473 C826.545455,678.510753 814.818182,671.672043 791.090909,671.672043 L791.090909,671.672043 Z M787,588.752688 L766.818182,588.752688 L766.818182,634.05914 L787,634.05914 C807.727273,634.05914 817,624.655914 817,610.123656 C817,595.021505 807.454545,588.752688 787,588.752688 L787,588.752688 Z"></path>
    </svg>
  );
};

export const HtmlIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      // fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M590.222222 73.955556L859.022222 342.254933V876.088889c0 37.700267-30.5664 68.266667-68.266666 68.266667H233.244444c-37.700267 0-68.266667-30.5664-68.266666-68.266667V142.222222c0-37.700267 30.5664-68.266667 68.266666-68.266666h356.977778z m-11.764622 28.444444H233.244444a39.822222 39.822222 0 0 0-39.799466 38.456889L193.422222 142.222222v733.866667a39.822222 39.822222 0 0 0 38.456889 39.799467L233.244444 915.911111h557.511112a39.822222 39.822222 0 0 0 39.799466-38.456889L830.577778 876.088889V354.053689L578.4576 102.4z"
        fill="currentColor"
      ></path>
      <path
        d="M854.755556 370.648178h-215.1424c-45.528178 0-82.551467-36.431644-83.5072-81.737956l-0.017067-1.792V73.955556h28.444444v213.162666c0 29.895111 23.819378 54.232178 53.515378 55.062756l1.564445 0.022755h215.1424v28.444445z"
        fill="currentColor"
      ></path>
      <path
        d="M56.888889 489.244444m28.444444 0l853.333334 0q28.444444 0 28.444444 28.444445l0 284.444444q0 28.444444-28.444444 28.444445l-853.333334 0q-28.444444 0-28.444444-28.444445l0-284.444444q0-28.444444 28.444444-28.444445Z"
        fill="currentColor"
      ></path>
      <path d="M207.200711 756.622222v-78.336h62.725689V756.622222h45.568V565.902222h-45.568v72.704H207.195022v-72.704h-45.818311V756.622222zM442.2144 756.622222v-152.576h51.712v-38.144h-148.992v38.144h51.450311V756.622222zM564.3264 756.622222v-65.28c0-18.944-3.584-47.36-5.888-66.048h1.024l15.36 45.568 25.850311 69.632h25.088l25.6-69.632 15.872-45.568h1.28c-2.56 18.688-6.144 47.104-6.144 66.048V756.622222h41.728V565.902222h-49.664l-29.184 82.432c-3.584 11.008-6.656 23.04-10.490311 34.56h-1.28c-3.584-11.52-6.656-23.552-10.496-34.56l-30.208-82.432h-49.413689V756.622222h40.96zM867.936711 756.622222v-38.4h-74.24V565.902222h-45.818311V756.622222z"></path>
    </svg>
  );
};

export const TxtIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M590.222222 73.955556L859.022222 342.254933V876.088889c0 37.700267-30.5664 68.266667-68.266666 68.266667H233.244444c-37.700267 0-68.266667-30.5664-68.266666-68.266667V142.222222c0-37.700267 30.5664-68.266667 68.266666-68.266666h356.977778z m-11.764622 28.444444H233.244444a39.822222 39.822222 0 0 0-39.799466 38.456889L193.422222 142.222222v733.866667a39.822222 39.822222 0 0 0 38.456889 39.799467L233.244444 915.911111h557.511112a39.822222 39.822222 0 0 0 39.799466-38.456889L830.577778 876.088889V354.053689L578.4576 102.4z"
        fill="currentColor"
      ></path>
      <path
        d="M854.755556 370.648178h-215.1424c-45.528178 0-82.551467-36.431644-83.5072-81.737956l-0.017067-1.792V73.955556h28.444444v213.162666c0 29.895111 23.819378 54.232178 53.515378 55.062756l1.564445 0.022755h215.1424v28.444445z"
        fill="currentColor"
      ></path>
      <path
        d="M56.888889 489.244444m28.444444 0l853.333334 0q28.444444 0 28.444444 28.444445l0 284.444444q0 28.444444-28.444444 28.444445l-853.333334 0q-28.444444 0-28.444444-28.444445l0-284.444444q0-28.444444 28.444444-28.444445Z"
        fill="currentColor"
      ></path>
      <path d="M371.615289 756.622222v-152.576h51.712v-38.144h-148.992v38.144h51.450311V756.622222h45.829689z m111.104 0l16.384-37.12c4.346311-9.984 8.704-19.968 13.050311-31.744h1.024c5.12 11.776 9.477689 21.76 14.085689 31.744L544.9216 756.622222h50.949689l-52.48-96 49.152-94.72h-48.384l-13.824 34.304a503.443911 503.443911 0 0 0-12.288 31.232h-1.024c-5.376-12.288-9.472-22.272-13.824-31.232l-15.36-34.304h-50.949689l49.413689 92.672L434.079289 756.622222h48.64z m220.928 0v-152.576h51.712v-38.144h-148.992v38.144h51.450311V756.622222h45.824z"></path>
    </svg>
  );
};

export const DocxIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      // fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M590.222222 73.955556L859.022222 342.254933V876.088889c0 37.700267-30.5664 68.266667-68.266666 68.266667H233.244444c-37.700267 0-68.266667-30.5664-68.266666-68.266667V142.222222c0-37.700267 30.5664-68.266667 68.266666-68.266666h356.977778z m-11.770311 28.438755H233.244444a39.827911 39.827911 0 0 0-39.799466 38.456889L193.422222 142.222222v733.866667a39.822222 39.822222 0 0 0 38.456889 39.799467L233.244444 915.911111h557.511112a39.822222 39.822222 0 0 0 39.799466-38.456889L830.577778 876.088889V354.053689l-252.125867-251.659378z"
        fill="currentColor"
      ></path>
      <path
        d="M854.755556 370.648178h-215.1424c-45.528178 0-82.551467-36.431644-83.5072-81.737956l-0.017067-1.792V73.955556h28.444444v213.162666c0 29.895111 23.819378 54.232178 53.515378 55.062756l1.564445 0.022755h215.1424v28.444445z"
        fill="currentColor"
      ></path>
      <path
        d="M56.888889 489.244444m28.444444 0l853.333334 0q28.444444 0 28.444444 28.444445l0 284.444444q0 28.444444-28.444444 28.444445l-853.333334 0q-28.444444 0-28.444444-28.444445l0-284.444444q0-28.444444 28.444444-28.444445Z"
        fill="currentColor"
      ></path>
      <path d="M303.530667 756.622222c55.552 0 93.952-29.952 93.952-96.256 0-66.304-38.4-94.464-96.512-94.464h-54.784V756.622222h57.344z m-5.376-36.864h-6.144v-117.248h6.144c30.72 0 52.48 12.544 52.48 57.856s-21.76 59.392-52.48 59.392z m213.248 40.448c51.968 0 87.296-37.376 87.296-99.84 0-62.208-35.328-97.792-87.296-97.792-51.968 0-87.296 35.328-87.296 97.792s35.328 99.84 87.296 99.84z m0-39.424c-25.088 0-40.448-23.552-40.448-60.416 0-36.864 15.36-58.624 40.448-58.624s40.704 21.76 40.704 58.624c0 36.864-15.616 60.416-40.704 60.416z m203.264 39.424c24.832 0 46.08-9.472 62.208-28.16l-24.064-28.672c-8.96 9.728-20.992 17.408-36.352 17.408-26.88 0-44.288-22.016-44.288-59.904 0-37.12 20.224-59.136 44.8-59.136 13.568 0 23.552 6.144 33.28 14.848l23.808-29.184c-13.056-13.312-33.024-24.832-57.856-24.832-48.384 0-90.88 36.352-90.88 99.84 0 64.512 40.96 97.792 89.344 97.792z"></path>
    </svg>
  );
};

export const WordIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      // fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M531.285 85.333h57.984v79.403c103.766 0.896 207.403-1.11 310.955 0.896a33.707 33.707 0 0 1 37.419 37.93c1.706 195.585 0 391.51 1.024 586.795a119.467 119.467 0 0 1-9.43 60.246 90.965 90.965 0 0 1-48.981 10.026H589.269v78.038h-60.202c-147.926-27.222-295.808-52.523-443.734-79.019V164.949c148.608-26.624 297.302-52.522 445.952-79.616z"
        fill="currentColor"
      ></path>
      <path
        d="M589.312 194.56h320v635.307h-320v-79.403h252.032V710.4H589.312v-49.195h252.032V620.8H589.312v-49.067h252.032v-40.149H589.312v-50.176h252.032v-38.656H589.312v-50.219h252.032v-39.168H589.312V303.66h252.032V264.02H589.312zM286.08 369.963c18.475-1.11 36.821-1.92 55.467-2.902 12.8 67.072 26.069 133.931 40.149 200.79 10.923-68.95 23.083-137.643 34.816-206.422 19.37-0.682 38.741-1.792 58.112-3.029-21.973 96.17-41.13 193.237-65.11 288.81-16.17 8.534-40.149 0-59.733 1.025-13.44-65.878-28.416-131.2-39.936-197.163-11.349 64-26.069 127.701-39.04 191.36a3627.52 3627.52 0 0 1-56.106-3.413c-16.043-87.339-35.03-174.166-50.176-261.718a3640.55 3640.55 0 0 1 50.176-2.09c10.026 63.232 21.333 126.208 30.08 189.525 13.44-64.939 27.392-129.792 41.344-194.773z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export const XlsxIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      // fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M590.222222 73.955556L859.022222 342.254933V876.088889c0 37.700267-30.5664 68.266667-68.266666 68.266667H233.244444c-37.700267 0-68.266667-30.5664-68.266666-68.266667V142.222222c0-37.700267 30.5664-68.266667 68.266666-68.266666h356.977778z m-11.764622 28.444444H233.244444a39.822222 39.822222 0 0 0-39.799466 38.456889L193.422222 142.222222v733.866667a39.822222 39.822222 0 0 0 38.456889 39.799467L233.244444 915.911111h557.511112a39.822222 39.822222 0 0 0 39.799466-38.456889L830.577778 876.088889V354.053689L578.4576 102.4z"
        fill="currentColor"
      ></path>
      <path
        d="M854.755556 370.648178h-215.1424c-45.528178 0-82.551467-36.431644-83.5072-81.737956l-0.017067-1.792V73.955556h28.444444v213.162666c0 29.895111 23.819378 54.232178 53.515378 55.062756l1.564445 0.022755h215.1424v28.444445z"
        fill="currentColor"
      ></path>
      <path
        d="M56.888889 489.244444m28.444444 0l853.333334 0q28.444444 0 28.444444 28.444445l0 284.444444q0 28.444444-28.444444 28.444445l-853.333334 0q-28.444444 0-28.444444-28.444445l0-284.444444q0-28.444444 28.444444-28.444445Z"
        fill="currentColor"
      ></path>
      <path d="M327.224889 756.622222l16.384-37.12c4.352-9.984 8.704-19.968 13.056-31.744h1.024c5.12 11.776 9.472 21.76 14.08 31.744L389.432889 756.622222h50.944l-52.48-96 49.152-94.72H388.664889l-13.824 34.304a503.443911 503.443911 0 0 0-12.288 31.232h-1.024c-5.376-12.288-9.472-22.272-13.824-31.232l-15.36-34.304h-50.944l49.408 92.672L278.584889 756.622222h48.64z m258.304 0v-38.4h-74.24V565.902222H465.464889V756.622222h120.064z m92.16 3.584c46.08 0 72.704-27.904 72.704-59.648 0-26.88-14.08-42.752-37.632-52.224l-23.808-9.472c-16.896-6.656-28.672-10.752-28.672-21.504 0-9.984 8.448-15.616 22.528-15.616 14.848 0 26.624 5.12 39.168 14.592l22.784-28.672c-16.64-16.64-39.936-25.088-61.952-25.088-40.448 0-69.12 25.6-69.12 57.6 0 27.648 18.688 44.288 38.656 52.224l24.32 10.24c16.384 6.912 26.88 10.496 26.88 21.504 0 10.24-7.936 16.64-24.832 16.64-15.104 0-32.768-7.936-46.08-19.456l-26.112 31.488c19.712 18.176 46.336 27.392 71.168 27.392z"></path>
    </svg>
  );
};

export const PptIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      // fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M590.222222 73.955556L859.022222 342.254933V876.088889c0 37.700267-30.5664 68.266667-68.266666 68.266667H233.244444c-37.700267 0-68.266667-30.5664-68.266666-68.266667V142.222222c0-37.700267 30.5664-68.266667 68.266666-68.266666h356.977778z m-11.764622 28.444444H233.244444a39.822222 39.822222 0 0 0-39.799466 38.456889L193.422222 142.222222v733.866667a39.822222 39.822222 0 0 0 38.456889 39.799467L233.244444 915.911111h557.511112a39.822222 39.822222 0 0 0 39.799466-38.456889L830.577778 876.088889V354.053689L578.4576 102.4z"
        fill="currentColor"
      ></path>
      <path
        d="M854.755556 370.648178h-215.1424c-45.528178 0-82.551467-36.431644-83.5072-81.737956l-0.017067-1.792V73.955556h28.444444v213.162666c0 29.895111 23.819378 54.232178 53.515378 55.062756l1.564445 0.022755h215.1424v28.444445z"
        fill="currentColor"
      ></path>
      <path
        d="M56.888889 489.244444m28.444444 0l853.333334 0q28.444444 0 28.444444 28.444445l0 284.444444q0 28.444444-28.444444 28.444445l-853.333334 0q-28.444444 0-28.444444-28.444445l0-284.444444q0-28.444444 28.444444-28.444445Z"
        fill="currentColor"
      ></path>
      <path d="M313.514667 756.622222v-63.232h22.272c40.448 0 75.264-19.968 75.264-65.28 0-47.104-34.56-62.208-76.288-62.208h-67.072V756.622222h45.824z m19.968-99.328h-19.968v-55.04h18.688c22.016 0 34.304 6.656 34.304 25.856 0 18.688-10.752 29.184-33.024 29.184zM489.386667 756.622222v-63.232h22.272c40.448 0 75.264-19.968 75.264-65.28 0-47.104-34.56-62.208-76.288-62.208H443.562667V756.622222h45.824z m19.968-99.328h-19.968v-55.04h18.688c22.016 0 34.304 6.656 34.304 25.856 0 18.688-10.752 29.184-33.024 29.184zM702.122667 756.622222v-152.576h51.712v-38.144h-148.992v38.144h51.456V756.622222h45.824z"></path>
    </svg>
  );
};

export const MarkdownIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path d="M128 128h768a42.666667 42.666667 0 0 1 42.666667 42.666667v682.666666a42.666667 42.666667 0 0 1-42.666667 42.666667H128a42.666667 42.666667 0 0 1-42.666667-42.666667V170.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z m170.666667 533.333333v-170.666666l85.333333 85.333333 85.333333-85.333333v170.666666h85.333334v-298.666666h-85.333334l-85.333333 85.333333-85.333333-85.333333H213.333333v298.666666h85.333334z m469.333333-128v-170.666666h-85.333333v170.666666h-85.333334l128 128 128-128h-85.333333z"></path>
    </svg>
  );
};
export const MarkdownGrayIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 20 18"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <g>
        <path
          d="M1,0L19,0C19.5523,0,20,0.44772,20,1L20,17C20,17.5523,19.5523,18,19,18L1,18C0.44772,18,0,17.5523,0,17L0,1C0,0.44772,0.44772,0,1,0ZM5,12.5L5,8.5L7,10.5L9,8.5L9,12.5L11,12.5L11,5.5L9,5.5L7,7.5L5,5.5L3,5.5L3,12.5L5,12.5ZM16,9.5L16,5.5L14,5.5L14,9.5L12,9.5L15,12.5L18,9.5L16,9.5Z"
          fill="#A6A6A6"
          fillOpacity="1"
        />
      </g>
    </svg>
  );
};
export const DocxGrayIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <g>
        <path
          d="M15,1.92356L19,1.92356C19.5523,1.92356,20,2.37128,20,2.92356L20,18.9236C20,19.4759,19.5523,19.9236,19,19.9236L15,19.9236L15,1.92356ZM0.85858,1.80091L13.4293,0.00508833C13.7027,-0.0339618,13.9559,0.155988,13.995,0.429358C13.9983,0.452778,14,0.476408,14,0.500068L14,21.3471C14,21.6232,13.7761,21.8471,13.5,21.8471C13.4763,21.8471,13.4527,21.8454,13.4293,21.842L0.85858,20.0462C0.36593,19.9758,0,19.5539,0,19.0563L0,2.79086C0,2.29321,0.36593,1.87129,0.85858,1.80091ZM9,6.92356L9,11.9126L7,9.92359L5.01083,11.9236L5,6.92356L3,6.92356L3,14.9236L5,14.9236L7,12.9236L9,14.9236L11,14.9236L11,6.92356L9,6.92356Z"
          fill="#A6A6A6"
          fillOpacity="1"
        />
      </g>
    </svg>
  );
};

export const AppleIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path d="M905.714286 694.285714q-22.285714 71.428571-70.285714 142.857143-73.714286 112-146.857143 112-28 0-80-18.285714-49.142857-18.285714-86.285714-18.285714-34.857143 0-81.142857 18.857143-46.285714 19.428571-75.428571 19.428571-86.857143 0-172-148-84-149.142857-84-287.428571 0-130.285714 64.571429-213.714286 64-82.285714 162.285714-82.285714 41.142857 0 101.142857 17.142857 59.428571 17.142857 78.857143 17.142857 25.714286 0 81.714286-19.428571 58.285714-19.428571 98.857143-19.428571 68 0 121.714286 37.142857 29.714286 20.571429 59.428571 57.142857-45.142857 38.285714-65.142857 67.428571-37.142857 53.714286-37.142857 118.285714 0 70.857143 39.428571 127.428571t90.285714 72zm-214.857143-670.285714q0 34.857143-16.571429 77.714286-17.142857 42.857143-53.142857 78.857143-30.857143 30.857143-61.714286 41.142857-21.142857 6.285714-59.428571 9.714286 1.714286-85.142857 44.571429-146.857143 42.285714-61.142857 142.857143-84.571429 0.571429 1.714286 1.428571 6.285714t1.428571 6.285714q0 2.285714 2.857143 5.714286t2.857143 5.714286z"></path>
    </svg>
  );
};

export const WindowsIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M456 484V160.1l-335.9 72V484H456zM512 484h391.8V64.2l-391.8 84V484zM456 540H120.2v251.9l335.9 72V540zM512 540v335.9l391.8 84V540H512z"
        fill="#00adef"
      ></path>
    </svg>
  );
};
export const McpIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <title>ModelContextProtocol</title>
      <path d="M15.688 2.343a2.588 2.588 0 00-3.61 0l-9.626 9.44a.863.863 0 01-1.203 0 .823.823 0 010-1.18l9.626-9.44a4.313 4.313 0 016.016 0 4.116 4.116 0 011.204 3.54 4.3 4.3 0 013.609 1.18l.05.05a4.115 4.115 0 010 5.9l-8.706 8.537a.274.274 0 000 .393l1.788 1.754a.823.823 0 010 1.18.863.863 0 01-1.203 0l-1.788-1.753a1.92 1.92 0 010-2.754l8.706-8.538a2.47 2.47 0 000-3.54l-.05-.049a2.588 2.588 0 00-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 01-1.204 0 .823.823 0 010-1.18l7.273-7.133a2.47 2.47 0 00-.003-3.537z"></path>
      <path d="M14.485 4.703a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a4.115 4.115 0 000 5.9 4.314 4.314 0 006.016 0l7.12-6.982a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a2.588 2.588 0 01-3.61 0 2.47 2.47 0 010-3.54l7.12-6.982z"></path>
    </svg>
  );
};

export const ChromeIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M123.648 178.346667C361.642667-98.602667 802.986667-43.946667 967.936 279.68h-396.501333c-71.424 0-117.546667-1.621333-167.509334 24.661333-58.709333 30.933333-102.997333 88.234667-118.485333 155.52L123.648 178.389333z"
        fill="#EA4335"
      ></path>
      <path
        d="M341.674667 512c0 93.866667 76.330667 170.24 170.154666 170.24 93.866667 0 170.154667-76.373333 170.154667-170.24s-76.330667-170.24-170.154667-170.24c-93.866667 0-170.154667 76.373333-170.154666 170.24z"
        fill="#4285F4"
      ></path>
      <path
        d="M577.877333 734.848c-95.530667 28.373333-207.274667-3.114667-268.501333-108.8-46.762667-80.64-170.24-295.765333-226.346667-393.557333-196.565333 301.226667-27.136 711.808 329.685334 781.866666l165.12-279.509333z"
        fill="#34A853"
      ></path>
      <path
        d="M669.866667 341.76a233.130667 233.130667 0 0 1 43.008 286.634667c-40.576 69.973333-170.154667 288.682667-232.96 394.581333 367.658667 22.656 635.733333-337.664 514.645333-681.258667H669.866667z"
        fill="#FBBC05"
      ></path>
    </svg>
  );
};

export const MpIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m256.717 460.186a151.962 151.962 0 0 1-87.347 65.74 83.251 83.251 0 0 1-24.474 4.096 29.082 29.082 0 0 1 0-58.163 15.667 15.667 0 0 0 6.451-1.229 91.443 91.443 0 0 0 55.91-40.96 75.264 75.264 0 0 0 11.06-39.628c0-45.978-42.496-83.866-94.31-83.866a105.267 105.267 0 0 0-51.2 13.414 81.92 81.92 0 0 0-43.725 70.452v244.224a138.445 138.445 0 0 1-72.704 120.422 159.642 159.642 0 0 1-79.77 20.48c-84.378 0-153.6-63.488-153.6-142.029a136.192 136.192 0 0 1 19.763-69.837 151.962 151.962 0 0 1 87.347-65.74 85.914 85.914 0 0 1 24.474-4.096 29.082 29.082 0 1 1 0 58.163 15.667 15.667 0 0 0-6.451 1.229 95.949 95.949 0 0 0-55.91 40.96 75.264 75.264 0 0 0-11.06 39.628c0 45.978 42.496 83.866 94.925 83.866a105.267 105.267 0 0 0 51.2-13.414 81.92 81.92 0 0 0 43.622-70.452V390.35a138.752 138.752 0 0 1 72.807-120.525 151.245 151.245 0 0 1 79.155-21.504c84.378 0 153.6 63.488 153.6 142.029a136.192 136.192 0 0 1-19.763 69.837z"
        fill="#00B240"
      ></path>
    </svg>
  );
};

export const StudentIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 1455 1024"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <path
        d="M1406.961225 224.573272l-769.220252 251.414363c-3.584422 1.228464-8.918983 1.295777-15.986857 0.168283l-52.84077-8.245852-115.610219-37.863609c-5.267249-1.682827-5.603814-4.08927-1.009697-7.236157l231.725287-161.04655c19.302026 8.296337 38.940618 9.709912 58.898948 4.207068 103.157299 3.197371 60.076926-104.503561-33.656542-87.00216-32.865613 1.127494-52.268609 17.720169-58.225816 49.811682l-258.818803 171.816643a18.729865 18.729865 0 0 1-15.145443 2.52424l-54.187032-14.472312-21.708469-3.533937a2040.713897 2040.713897 0 0 0-250.57295-86.665594c-46.61431-12.789486-62.432884-51.494508-6.563026-69.66904a16355.917924 16355.917924 0 0 0 328.656126-110.056891c28.50709 1.800625 53.749496-6.175975 75.727218-23.896144l246.1976-81.280547c20.53049-6.731308 40.842213-6.849106 60.91834-0.336566l651.422357 211.36308z"
        fill="#918191"
        p-id="3395"
      ></path>
      <path
        d="M448.422928 94.827305c-21.977721 17.720169-47.220127 25.696769-75.727218 23.896144a180.651485 180.651485 0 0 1 75.727218-23.896144z"
        fill="#CBC5CB"
        p-id="3396"
      ></path>
      <path
        d="M709.261123 178.968658c20.648288 25.578971 31.872745 54.574082 33.656542 87.00216-19.958329 5.502845-39.596921 4.08927-58.898948-4.207068 0.454363-22.886448-10.534497-33.875309-32.98341-32.98341 5.957208-32.091512 25.360204-48.684187 58.225816-49.811682z"
        fill="#685E67"
        p-id="3397"
      ></path>
      <path
        d="M709.261123 178.968658c93.733468-17.501401 136.81384 90.199531 33.656542 87.00216-1.783797-32.428078-13.008253-61.423188-33.656542-87.00216z"
        fill="#554E54"
        p-id="3398"
      ></path>
      <path
        d="M651.035307 228.78034c22.448913-0.891898 33.437774 10.096962 32.98341 32.98341l-231.725287 161.04655c-4.594118 3.146887-4.257552 5.553329 1.009697 7.236157l115.610219 37.863609 149.098478 54.860162c4.442663 1.632342 10.197932 1.396746 16.15514-0.673131l416.163133-137.655254a1097.724923 1097.724923 0 0 1 30.795735 210.353383c9.592114 51.494508-31.805432 54.523597-67.986213 63.779146l-10.096962-5.048481c-3.870502-1.85111-6.731308-6.71448-7.572722-12.789486l-21.035339-145.901106a7.067874 7.067874 0 0 0-3.449795-5.048482 7.774661 7.774661 0 0 0-6.310602-0.67313l-322.261383 104.671843c-5.284077 1.649171-10.938376 1.834282-16.323422 0.504848-109.552042-27.093516-215.401864-78.756307-323.775927-100.801341-48.970268-10.096962-142.198887-31.468866-79.429438-104.840126l54.187032 14.472312c5.031653 1.396746 10.534497 0.471192 15.145443-2.52424l258.818803-171.816643z"
        fill="#554E54"
        p-id="3399"
      ></path>
      <path
        d="M1406.961225 224.573272c60.076926 20.025642 46.950875 57.552686-1.346262 73.539543a16253.517897 16253.517897 0 0 0-255.284866 86.329028l-416.163133 137.655254c-5.957208 2.069877-11.712476 2.305473-16.15514 0.673131l-149.098478-54.860162 52.84077 8.245852c7.067874 1.127494 12.402435 1.060181 15.986857-0.168283l769.220252-251.414363z"
        fill="#7A6D79"
        p-id="3400"
      ></path>
      <path
        d="M301.17556 385.114974l21.708469 3.533937c-62.76945 73.37126 30.45917 94.743164 79.429438 104.840126 108.374063 22.045035 214.223885 73.707825 323.775927 100.801341 5.385047 1.329433 11.039346 1.144322 16.323422-0.504848l322.261383-104.671843a7.774661 7.774661 0 0 1 6.310602 0.67313 7.067874 7.067874 0 0 1 3.449795 5.048482l21.035339 145.901106c0.841414 6.075006 3.70222 10.938376 7.572722 12.789486l10.096962 5.048481-16.828271 11.274941a294.9491 294.9491 0 0 0-117.797894 42.070677l-109.38376 37.863609c-22.650852-1.901595-42.289444 5.098966-58.898947 21.035338l-134.626165 47.624006c-28.60806 4.156583-49.643398 19.133744-63.106015 44.931483l-46.277744 5.553329-83.468223-17.501401-35.002803-231.388722c30.964018-36.803428 30.526483-70.005606-1.346261-99.623362a22.785478 22.785478 0 0 0-14.808879-6.058177c-82.22293-4.156583-101.642755 32.478562-58.225816 109.888607l-30.795735 172.489774c-29.836524-10.096962-53.009053-27.648849-69.500758-52.672487a27.127172 27.127172 0 0 1-4.37535-15.482009c2.473756-115.324139 13.294334-229.823692 32.478562-343.465004z"
        fill="#685E67"
        p-id="3401"
      ></path>
      <path
        d="M447.749797 620.037632l-49.13855 4.207068h-25.242406c-43.416938-77.410045-23.997114-114.04519 58.225816-109.888607 5.637471 0.218768 10.904719 2.355958 14.808879 6.058177 31.872745 29.617756 32.31028 62.819934 1.346261 99.623362z"
        fill="#FDDD44"
        p-id="3402"
      ></path>
      <path
        d="M1417.058187 610.445518l-24.569275 68.491062c-2.019392 5.553329-5.671127 9.693084-9.92868 11.274941l-209.848535 77.073479c-14.909848-41.397546-40.38785-73.876108-76.400349-97.435687l16.828271-11.274941c36.180782-9.255549 77.578328-12.284638 67.986213-63.779146 6.394743 13.243849 16.104655 22.499398 29.112909 27.766647 4.745572 1.817453 10.433528 1.514544 15.818574-0.841414 54.355314-24.064427 147.583934-78.419741 191.000872-11.274941z"
        fill="#F1EFF2"
        p-id="3403"
      ></path>
      <path
        d="M1417.058187 610.445518c21.657984 33.538743 30.863048 67.935729 27.598364 103.157299-2.019392 22.549883-14.186232 38.082376-36.517348 46.61431l-236.26892 90.872661-0.504848-41.734111v-29.449474l1.346262-12.621203 209.848535-77.073479c4.257552-1.581857 7.909287-5.721612 9.92868-11.274941l24.569275-68.491062z"
        fill="#E1DDE1"
        p-id="3404"
      ></path>
      <path
        d="M398.611247 624.2447c-2.860806 14.135747-7.572722 23.559579-5.048481 38.200174a2093.369556 2093.369556 0 0 1 29.786039 323.102797l-68.491062-5.216764c-9.642599-0.7741-16.962897-10.029649-16.659988-21.035338l4.375351-162.561095 30.795735-172.489774h25.242406z"
        fill="#FCD430"
        p-id="3405"
      ></path>
      <path
        d="M447.749797 620.037632l35.002803 231.388722-1.177979 109.552042c-0.10097 6.125491-2.221332 11.325426-5.721612 13.967464-12.335122 9.642599-29.836524 13.176536-52.504204 10.601811a2093.369556 2093.369556 0 0 0-29.786039-323.102797c-2.524241-14.640595 2.187675-24.064427 5.048481-38.200174l49.13855-4.207068z"
        fill="#E6B729"
        p-id="3406"
      ></path>
      <path
        d="M1096.311348 669.849313c36.012499 23.559579 61.490501 56.038141 76.400349 97.435687l-1.346262 12.621203c-38.587225-1.127494-71.789403 11.493709-99.623362 37.863609l-8.414135-21.035338c-6.276945-50.939175-34.54844-79.21067-84.814484-84.814484a294.9491 294.9491 0 0 1 117.797894-42.070677z"
        fill="#FC9743"
        p-id="3407"
      ></path>
      <path
        d="M978.513454 711.91999c50.266044 5.603814 78.537539 33.875309 84.814484 84.814484 1.009696 6.512541-1.682827 10.988861-8.07757 13.462617-146.84349 56.761757-244.34649 92.437691-292.475344 107.027801-14.354515 4.37535-26.353072-2.13719-36.012499-19.520794l-51.157943-79.261155 134.626165-47.624006a100.010412 100.010412 0 0 0 58.898947-21.035338l109.38376-37.863609z"
        fill="#F1EFF2"
        p-id="3408"
      ></path>
      <path
        d="M869.129694 749.783599a100.010412 100.010412 0 0 1-58.898947 21.035338c16.609503-15.936372 36.248095-22.936933 58.898947-21.035338z"
        fill="#A69CA7"
        p-id="3409"
      ></path>
      <path
        d="M1171.365435 779.906203v29.449474c-9.979164 31.754947-33.925794 53.850466-71.856715 66.303386-21.641156 7.067874-31.351068-1.009696-29.112909-24.232709l1.346262-33.656542c27.83396-26.3699 61.036138-38.991103 99.623362-37.863609z"
        fill="#FA7621"
        p-id="3410"
      ></path>
      <path
        d="M1063.327938 796.734474l8.414135 21.035338-1.346262 33.656542-16.82827 42.070676-329.329257 117.124764c13.580414-39.041588 14.421828-76.686429 2.524241-112.917696 9.659427 17.383604 21.657984 23.896144 36.012499 19.520794 48.128854-14.590111 145.631854-50.266044 292.475344-107.027801 6.394743-2.473756 9.087266-6.950076 8.07757-13.462617z"
        fill="#E1DDE1"
        p-id="3411"
      ></path>
      <path
        d="M1171.365435 809.355677l0.504848 41.734111c44.544432 11.661992 78.083176 31.519351 100.633059 59.572078 3.399311 4.207068 4.644603 9.760397 3.348826 14.926676a16.020514 16.020514 0 0 1-9.911852 11.157144l-97.772252 36.349065a15.986857 15.986857 0 0 1-13.075566-1.060182 16.676816 16.676816 0 0 1-8.128055-10.551325c-13.227021-50.60261-44.359321-73.253462-93.396902-67.986214l16.82827-42.070676c-2.23816 23.223014 7.471752 31.300583 29.112909 24.232709 37.930922-12.45292 61.877551-34.54844 71.856715-66.303386z"
        fill="#FC9743"
        p-id="3412"
      ></path>
      <path
        d="M675.604582 818.442943l51.157943 79.261155c11.897587 36.231267 11.056174 73.876108-2.524241 112.917696a84.612545 84.612545 0 0 1-40.219567 4.207068c-23.727862-56.038141 24.064427-130.082532-71.52015-151.454436 13.462617-25.797739 34.497955-40.7749 63.106015-44.931483z"
        fill="#A69CA7"
        p-id="3413"
      ></path>
      <path
        d="M612.498567 863.374426c95.584577 21.371904 47.792289 95.416295 71.52015 151.454436-57.384403-25.915537-58.394099-85.487615-80.775699-133.784752-1.85111-4.190239-6.663995-6.596682-11.779789-5.889895-9.087266 1.009696-17.501401-1.060181-25.242406-6.22646l46.277744-5.553329z"
        fill="#B6ADB6"
        p-id="3414"
      ></path>
    </svg>
  );
};

export const NeuralIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="6"
      cy="6"
      r="3"
      className="stroke-science-500 stroke-2 fill-science-50/50 animate-pulse"
    />
    <circle
      cx="18"
      cy="6"
      r="3"
      className="stroke-science-500 stroke-2 fill-science-50/50 animate-pulse delay-75"
    />
    <circle
      cx="6"
      cy="18"
      r="3"
      className="stroke-science-500 stroke-2 fill-science-50/50 animate-pulse delay-150"
    />
    <circle
      cx="18"
      cy="18"
      r="3"
      className="stroke-science-500 stroke-2 fill-science-50/50 animate-pulse delay-300"
    />

    <path d="M9 6H15" className="stroke-slate-300 stroke-[1.5]" />
    <path d="M6 9V15" className="stroke-slate-300 stroke-[1.5]" />
    <path d="M18 9V15" className="stroke-slate-300 stroke-[1.5]" />
    <path d="M9 18H15" className="stroke-slate-300 stroke-[1.5]" />
    <path
      d="M8.5 8.5L15.5 15.5"
      className="stroke-science-400 stroke-[1.5] animate-[dash_2s_ease-in-out_infinite]"
      strokeDasharray="4 2"
    />
    <path
      d="M15.5 8.5L8.5 15.5"
      className="stroke-science-400 stroke-[1.5] animate-[dash_3s_ease-in-out_infinite]"
      strokeDasharray="4 2"
    />
  </svg>
);

export const FileTypeIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Base Document */}
    <path
      d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
      className="stroke-slate-300 stroke-2 fill-white"
    />
    <path d="M14 2V8H20" className="stroke-slate-300 stroke-2" />

    {/* Animated Floating Badges */}
    <g className="animate-float">
      <rect
        x="2"
        y="10"
        width="8"
        height="6"
        rx="1"
        className="fill-science-500 shadow-xs"
      />
      <text
        x="4"
        y="14"
        fontSize="3"
        fill="white"
        fontWeight="bold"
        fontFamily="sans-serif"
      >
        PDF
      </text>
    </g>

    <g className="animate-float delay-1000" style={{ animationDelay: '1s' }}>
      <rect
        x="14"
        y="14"
        width="8"
        height="6"
        rx="1"
        className="fill-emerald-500 shadow-xs"
      />
      <text
        x="15"
        y="18"
        fontSize="3"
        fill="white"
        fontWeight="bold"
        fontFamily="sans-serif"
      >
        XLS
      </text>
    </g>
  </svg>
);

export const ZapIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" className="stroke-slate-200 stroke-1" />
    <circle
      cx="12"
      cy="12"
      r="6"
      className="stroke-science-200 stroke-1 animate-ping opacity-20"
    />

    <path
      d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
      className="stroke-yellow-500 stroke-2 fill-yellow-100 group-hover:fill-yellow-400 transition-colors duration-300 ease-in-out"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

export const GlobeIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Globe sphere background */}
    <circle
      cx="12"
      cy="12"
      r="10"
      className="fill-slate-50 dark:fill-slate-800/50 stroke-slate-300 dark:stroke-slate-600 stroke-2"
    />

    {/* Longitude Lines */}
    <ellipse
      cx="12"
      cy="12"
      rx="4"
      ry="10"
      className="stroke-slate-300 dark:stroke-slate-600 stroke-[1.5]"
    />
    <path
      d="M12 2V22"
      className="stroke-slate-300 dark:stroke-slate-600 stroke-[1.5]"
    />

    {/* Latitude Lines */}
    <path
      d="M2.5 9C2.5 9 5.5 10 12 10C18.5 10 21.5 9 21.5 9"
      className="stroke-slate-300 dark:stroke-slate-600 stroke-[1.5]"
    />
    <path
      d="M2.5 15C2.5 15 5.5 14 12 14C18.5 14 21.5 15 21.5 15"
      className="stroke-slate-300 dark:stroke-slate-600 stroke-[1.5]"
    />

    {/* Orbiting Satellite */}
    <path
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z"
      className="stroke-science-400/30 dark:stroke-science-400/20 stroke-1"
      strokeDasharray="2 2"
    />
    <circle
      r="1.5"
      className="fill-science-500 dark:fill-science-400 filter drop-shadow-md"
    >
      <animateMotion
        dur="6s"
        repeatCount="indefinite"
        path="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z"
      />
    </circle>
  </svg>
);

export const RoundedSquareIcon = ({
  fill = 'currentColor',
  size,
  height,
  width,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      viewBox="0 0 267 267"
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      {...props}
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path
          d="M267,0 C121.014572,0 2.39359144,117.161126 0.0357703716,262.584667 L0,267 L0,0 L267,0 Z"
          fill={fill}
        ></path>
      </g>
    </svg>
  );
};
